export const TEXT = 'text'
export const PASSWORD = 'password'
